export const INJECT_FORM_PAGE = Symbol(
  'useFormPage composable'
) as InjectionKey<UseFormStrategy>;

export const useFormPage = async (
  context: MultiStepContext | SingleStepContext,
  body: any = null
): Promise<UseFormStrategy> => {
  const formStrategy = useFormStrategy(context);

  await formStrategy.fetch(body);

  return {
    ...formStrategy,
  };
};
